import { render, staticRenderFns } from "./summarySidebar.vue?vue&type=template&id=b40191bc&scoped=true&"
import script from "./summarySidebar.vue?vue&type=script&lang=js&"
export * from "./summarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40191bc",
  null
  
)

/* custom blocks */
import block0 from "./summarySidebar.vue?vue&type=custom&index=0&blockType=div&class=arrow%20arrow--right"
if (typeof block0 === 'function') block0(component)
import block1 from "./summarySidebar.vue?vue&type=custom&index=1&blockType=div&class=intro-label"
if (typeof block1 === 'function') block1(component)
import block2 from "./summarySidebar.vue?vue&type=custom&index=2&blockType=div&class=booking-summary__subsection&v-for=section%20in%20summary&%40click=stepBackTo(section.section)"
if (typeof block2 === 'function') block2(component)
import block3 from "./summarySidebar.vue?vue&type=custom&index=3&blockType=div&class=booking-summary__price%20sans-serif&v-if=currentPrice"
if (typeof block3 === 'function') block3(component)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20250624160434/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40191bc')) {
      api.createRecord('b40191bc', component.options)
    } else {
      api.reload('b40191bc', component.options)
    }
    module.hot.accept("./summarySidebar.vue?vue&type=template&id=b40191bc&scoped=true&", function () {
      api.rerender('b40191bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/booking/summarySidebar.vue"
export default component.exports